import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NotificationNavigateListener = (): null => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const onMessage = (event: MessageEvent) => {
      if (event.data?.type === "seevi-notification-navigate" && event.data.url) {
        navigate(event.data.url);
      }
    };

    navigator.serviceWorker.addEventListener("message", onMessage);
    return () => navigator.serviceWorker.removeEventListener("message", onMessage);
  }, [navigate]);

  return null;
};

export default NotificationNavigateListener;
